import { Component, Input, OnInit, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import * as Feather from 'feather-icons';

@Component({
  selector: 'app-layout-step-fourniss',
  templateUrl: './layout-step-fourniss.component.html',
  styleUrls: ['./layout-step-fourniss.component.scss']
})
export class LayoutStepFournissComponent implements OnInit {

    @Input() steps: string[] = [];
    @Input() currentStep: number = 0;
    @Output() stepSelected = new EventEmitter<number>();
    @Output() goBack = new EventEmitter<void>();

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(private router: Router) {}

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        const checkIcons = document.querySelectorAll('.check-container [data-feather="check"]');
        checkIcons.forEach((icon: any) => {
            Feather.replace({ 'check': { stroke: '#fff' } }, icon);
        });
    }

    onStepClick(index: number): void {
        if (index <= this.currentStep) {
            this.stepSelected.emit(index);
        }
    }

    onGoBack(): void {
        this.router.navigate(['/bibliotheque-fournisseurs/actif']);
    }


    retour(event?: Event): void {
        if (event) {
            event.stopPropagation();
        }
        this.router.navigate(['/bibliotheque-fournisseurs/actif']).then(success => {
        });
    }

    num(i: any): string {
        return `0${i + 1}`.slice(-2);
    }

    getProgress(): number {
        if (this.steps.length <= 1) return 0;
        return (this.currentStep / (this.steps.length - 1)) * 100;
    }

    isStepsArray(): boolean {
        return Array.isArray(this.steps);
    }

}
